import { Next, Previous } from '../icons';

const ImageSliderArrow = (props) => {
  const { direction, handleArrowScroll } = props;
  return (
    <div className={`slider-arrow ${direction}`} onClick={() => handleArrowScroll(direction)}>
      {direction === 'left' && <Previous />}
      {direction === 'right' && <Next />}
    </div >
  );
};

export default ImageSliderArrow;
